module.exports = __webpack_public_path__ + "img/zd.d477b785.png";